// src/data/projects.ts
export type Project = {
  id: string;
  title: string;
  description: string;
  tech: string[];
  group: string; // e.g., 'Hardware', 'Firmware', 'Cloud'
  githubUrl?: string;
  x?: number;
  y?: number;
  fx?: number | null;
  fy?: number | null;
};

export const projects: Project[] = [
  {
    id: 'esp32-devboard',
    title: 'ESP32 Devboard',
    description: 'A custom ESP32 development board featuring USB-C connectivity, integrated LiPo charging, and dedicated debug headers.',
    tech: ['PCB Design', 'KiCad', 'Embedded C', 'Power Management'],
    group: 'Hardware',
    githubUrl: 'https://github.com/aakashvishcoder/ESP32-Devboard.git',
  },
  {
    id: 'sprig',
    title: 'Sprig Game',
    description: 'A JavaScript-based game inspired by Conway’s Game of Life, developed for Hack Club’s Sprig platform.',
    tech: ['Javascript', 'Games'],
    group: 'Games',
    githubUrl:'https://github.com/aakashvishcoder/sprig',
  },
  {
    id: 'spell-forge',
    title: 'Spell Forge',
    description: 'An interactive magic simulation website developed for Hack Club’s Siege hackathon.',
    tech: ['React', 'Node.js', 'Javascript', 'Games','CSS'],
    group: 'Games',
    githubUrl: 'https://github.com/aakashvishcoder/SpellForge.git',
  },
  {
    id: 'healthcare-chatbot',
    title: 'Healthcare Chatbot',
    description: 'A web-based AI chatbot powered by a pretrained large language model, developed for the Congressional App Challenge.',
    tech: ['React', 'Node.js', 'MQTT', 'Javascript', 'Python', 'Transformers','PyTorch','AI','CSS'],
    group: 'AI',
    githubUrl: 'https://github.com/aakashvishcoder/healthcare-chatbot.git',
  },
  {
    id: 'transformer',
    title: 'Transformer',
    description: 'An ongoing project building the Transformer architecture entirely from scratch.',
    tech: ['C++','AI'],
    group: 'AI',
    githubUrl: 'https://github.com/aakashvishcoder/Transformer.git',
  },
  {
    id: 'sacrifice-the-baby',
    title: 'Sacrifice the Baby',
    description: 'A 2D platformer game featuring a unique health system, created for Hack Club’s Daydream Hackathon.',
    tech: ['C#','Games',"Unity"],
    group: 'Games',
    githubUrl: 'https://github.com/aakashvishcoder/Sacrifice-the-Babies.git',
  },
  {
    id: 'maker-dawgs-website',
    title: 'Maker Dawgs Website',
    description: 'An official website designed and developed for my school’s engineering club.',
    tech: ['HTML','CSS',"Javascript"],
    group: 'Website',
    githubUrl: 'https://github.com/aakashvishcoder/MakerDawgs-Website.git',
  },
  {
    id: 'photo-gallery',
    title: 'Photo Gallery',
    description: 'A dynamic gallery website that enables users to upload, manage, and organize photos seamlessly.',
    tech: ['React','Node.js',"CSS","Javascript"],
    group: 'Website',
    githubUrl: 'https://github.com/aakashvishcoder/photo-gallery.git',
  },
  {
    id: 'dice-roller',
    title: 'Dice Roller',
    description: 'A simple random dice roller built using an Arduino Uno and breadboard components.',
    tech: ['C++','Arduino'],
    group: 'Hardware',
    githubUrl: 'https://github.com/aakashvishcoder/Dice-Roller.git',
  },
  {
    id: 'mini-focalboard',
    title: 'Mini Focalboard',
    description: 'A lightweight recreation of a Trello-style productivity board for task management.',
    tech: ['React','Node.js',"CSS","Javascript"],
    group: 'Website',
    githubUrl: 'https://github.com/aakashvishcoder/Mini-Focalboard.git',
  },
  {
    id: 'ai-image-generator',
    title: 'AI Image Generator',
    description: 'A pretrained AI image generation model paired with an intuitive web-based interface.',
    tech: ['React','Node.js',"CSS","Javascript","Python","AI"],
    group: 'AI',
    githubUrl: 'https://github.com/aakashvishcoder/ai-image-generator.git',
  },
  {
    id: 'transfer-market',
    title: 'Transfer Market Predictor',
    description: 'A neural network trained on professional soccer data to estimate players’ market values.',
    tech: ["Python","AI","PyTorch"],
    group: 'AI',
    githubUrl: 'https://github.com/aakashvishcoder/Transfer-Market.git',
  },
  {
    id: 'dex-contract-using-solidity',
    title: 'Dex Contract Using Solidity',
    description: 'A decentralized finance project focused on building a functional decentralized exchange (DEX) smart contract.',
    tech: ["Solidity"],
    group: 'Finance',
    githubUrl: 'https://github.com/aakashvishcoder/DEX-Contract-using-solidity.git',
  },
  {
    id: 'pretrained-chatbot',
    title: 'Pretrained Chatbot',
    description: 'An experimental project exploring the pretraining of a large language model from scratch.',
    tech: ["Python","AI","Transformers"],
    group: 'AI',
    githubUrl: 'https://github.com/aakashvishcoder/Pretrained-Chatbot.git',
  },
  {
    id: 'image-to-ascii-art',
    title: 'Image to ASCII Art',
    description: 'A web application that converts uploaded images into stylized ASCII art representations.',
    tech: ['React','Node.js',"CSS","Javascript"],
    group: 'Website',
    githubUrl: 'https://github.com/aakashvishcoder/image-to-ascii-art.git',
  },
  {
    id: 'neural-network-from-scratch',
    title: 'Neural Network from Scratch',
    description: 'A fully custom neural network architecture implemented solely with NumPy.',
    tech: ["Python","AI"],
    group: 'AI',
    githubUrl: 'https://github.com/aakashvishcoder/NeuralNetworkFromScratch.git',
  },
  {
    id: 'cpp-blockchain',
    title: 'Blockchain',
    description: 'A simplified blockchain implementation that mirrors core cryptocurrency ledger mechanics.',
    tech: ["C++"],
    group: 'Finance',
    githubUrl: 'https://github.com/aakashvishcoder/cppblockchain.git',
  },
  {
    id: 'mini-sql-database',
    title: 'Database',
    description: 'A C++-based database system replicating core functionalities of MySQL and PostgreSQL.',
    tech: ["C++","SQL"],
    group: 'Finance',
    githubUrl: 'https://github.com/aakashvishcoder/MiniSQL-Database.git',
  },
  {
    id: 'deepfake-image-detector',
    title: 'Deepfake Image Detector',
    description: 'A convolutional neural network designed to identify and classify deepfaked images.',
    tech: ["Python","AI","PyTorch"],
    group: 'AI',
    githubUrl: 'https://github.com/aakashvishcoder/Deepfake-Image-Detector.git',
  },
  {
    id: 'time-series-forecasting',
    title: 'Time Series Forecasting',
    description: 'An LSTM/RNN model developed for predictive analysis of time-series datasets.',
    tech: ["Python","AI","PyTorch"],
    group: 'AI',
    githubUrl: 'https://github.com/aakashvishcoder/TimeSeriesForecasting.git',
  },
  {
    id: 'fake-news-classifier',
    title: 'Fake News Classifier',
    description: 'An LSTM/RNN-based neural network built to detect and classify fake news articles.',
    tech: ["Python","AI","PyTorch"],
    group: 'AI',
    githubUrl: 'https://github.com/aakashvishcoder/FakeNewsClassifier.git',
  },
  {
    id: 'brain-tumor-classification-CNN',
    title: 'Brain Tumor Classification',
    description: 'A convolutional neural network designed to detect and classify malignant brain tumors from imaging data.',
    tech: ["Python","AI","PyTorch"],
    group: 'AI',
    githubUrl: "https://github.com/aakashvishcoder/BrainTumorClassificationCNN.git",
  },
  {
    id: 'EMNIST-letter-predictor',
    title: 'EMNIST Letter Predictor',
    description: 'A convolutional neural network trained on the EMNIST dataset to recognize handwritten letters.',
    tech: ["Python","AI","PyTorch"],
    group: 'AI',
    githubUrl: 'https://github.com/aakashvishcoder/EMNIST-Letter-Predictor.git',
  },
  {
    id: 'signal-scope',
    title: 'Signal Scope',
    description: 'An interactive website that allows you to input your own music, and or your own voice, and express them as waves and signals in real time! (Made for Hackclub\'s Siege)',
    tech: ['React','Node.js',"CSS","Typescript","Python",'Three.js'],
    group: 'Website',
    githubUrl: 'https://github.com/aakashvishcoder/SignalScope.git',
  },
];